export function toBase32(number) {
  const alphabet = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
  let result = '';
  while (number > 0) {
    result = alphabet[number % 32] + result;
    number = Math.floor(number / 32);
  }
  return result || '0';
}
